export const prolificCountries = [
  {
    __typename: 'Country' as const,
    name: 'UK',
    countryCode: 'GB',
    languageName: 'English (UK)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'GB'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Australia',
    countryCode: 'AU',
    languageName: 'English (AU)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'AU'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'USA',
    countryCode: 'US',
    languageName: 'English (US)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'US'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Germany',
    countryCode: 'DE',
    languageName: 'German',
    locale: {
      __typename: 'Locale' as const,
      language: 'de',
      country: 'DE'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'France',
    countryCode: 'FR',
    languageName: 'French',
    locale: {
      __typename: 'Locale' as const,
      language: 'fr',
      country: 'FR'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Italy',
    countryCode: 'IT',
    languageName: 'Italy',
    locale: {
      __typename: 'Locale' as const,
      language: 'it',
      country: 'IT'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Spain',
    countryCode: 'ES',
    languageName: 'Spanish',
    locale: {
      __typename: 'Locale' as const,
      language: 'es',
      country: 'ES'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Netherlands',
    countryCode: 'NL',
    languageName: 'Dutch',
    locale: {
      __typename: 'Locale' as const,
      language: 'nl',
      country: 'NL'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Brazil',
    countryCode: 'BR',
    languageName: 'Portuguese',
    locale: {
      __typename: 'Locale' as const,
      language: 'pt',
      country: 'BR'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Portugal',
    countryCode: 'PT',
    languageName: 'Portuguese',
    locale: {
      __typename: 'Locale' as const,
      language: 'pt',
      country: 'PT'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Austria',
    countryCode: 'AT',
    languageName: 'German',
    locale: {
      __typename: 'Locale' as const,
      language: 'de',
      country: 'AT'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Denmark',
    countryCode: 'DK',
    languageName: 'Danish',
    locale: {
      __typename: 'Locale' as const,
      language: 'da',
      country: 'DK'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Greece',
    countryCode: 'GR',
    languageName: 'Greek',
    locale: {
      __typename: 'Locale' as const,
      language: 'el',
      country: 'GR'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'India',
    countryCode: 'IN',
    languageName: 'English (IN)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'IN'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Indonesia',
    countryCode: 'ID',
    languageName: 'Indonesian',
    locale: {
      __typename: 'Locale' as const,
      language: 'id',
      country: 'ID'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Hungary',
    countryCode: 'HU',
    languageName: 'Hungarian',
    locale: {
      __typename: 'Locale' as const,
      language: 'hu',
      country: 'HU'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Japan',
    countryCode: 'JP',
    languageName: 'Japanese',
    locale: {
      __typename: 'Locale' as const,
      language: 'ja',
      country: 'JP'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Norway',
    countryCode: 'NO',
    languageName: 'Norwegian',
    locale: {
      __typename: 'Locale' as const,
      language: 'nb',
      country: 'NO'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Poland',
    countryCode: 'PL',
    languageName: 'Polish',
    locale: {
      __typename: 'Locale' as const,
      language: 'pl',
      country: 'PL'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Sweden',
    countryCode: 'SE',
    languageName: 'Swedish',
    locale: {
      __typename: 'Locale' as const,
      language: 'sv',
      country: 'SE'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Belgium',
    countryCode: 'BE',
    languageName: 'French',
    locale: {
      __typename: 'Locale' as const,
      language: 'fr',
      country: 'BE'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Belgium',
    countryCode: 'BE',
    languageName: 'Dutch',
    locale: {
      __typename: 'Locale' as const,
      language: 'nl',
      country: 'BE'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Israel',
    countryCode: 'IL',
    languageName: 'English (International)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'IL'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Israel',
    countryCode: 'IL',
    languageName: 'Hebrew',
    locale: {
      __typename: 'Locale' as const,
      language: 'he',
      country: 'IL'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Finland',
    countryCode: 'FI',
    languageName: 'Finnish',
    locale: {
      __typename: 'Locale' as const,
      language: 'fi',
      country: 'FI'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Estonia',
    countryCode: 'EE',
    languageName: 'Estonian',
    locale: {
      __typename: 'Locale' as const,
      language: 'et',
      country: 'EE'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Switzerland',
    countryCode: 'CH',
    languageName: 'German (CH)',
    locale: {
      __typename: 'Locale' as const,
      language: 'de',
      country: 'CH'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Switzerland',
    countryCode: 'CH',
    languageName: 'French (CH)',
    locale: {
      __typename: 'Locale' as const,
      language: 'fr',
      country: 'CH'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Slovakia',
    countryCode: 'SK',
    languageName: 'Slovak',
    locale: {
      __typename: 'Locale' as const,
      language: 'sk',
      country: 'SK'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Slovenia',
    countryCode: 'SI',
    languageName: 'Slovene',
    locale: {
      __typename: 'Locale' as const,
      language: 'sl',
      country: 'SI'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Latvia',
    countryCode: 'LV',
    languageName: 'Latvian',
    locale: {
      __typename: 'Locale' as const,
      language: 'lv',
      country: 'LV'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'New Zealand',
    countryCode: 'NZ',
    languageName: 'English (NZ)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'NZ'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Canada',
    countryCode: 'CA',
    languageName: 'English (CA)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'CA'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'South Africa',
    countryCode: 'ZA',
    languageName: 'English (ZA)',
    locale: {
      __typename: 'Locale' as const,
      language: 'en',
      country: 'ZA'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Czech Republic',
    countryCode: 'CZ',
    languageName: 'Czech',
    locale: {
      __typename: 'Locale' as const,
      language: 'cs',
      country: 'CZ'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Chile',
    countryCode: 'CL',
    languageName: 'Spanish',
    locale: {
      __typename: 'Locale' as const,
      language: 'es',
      country: 'CL'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'South Korea',
    countryCode: 'KR',
    languageName: 'Korean',
    locale: {
      __typename: 'Locale' as const,
      language: 'ko',
      country: 'KR'
    }
  },
  {
    __typename: 'Country' as const,
    name: 'Croatia',
    countryCode: 'HR',
    languageName: 'Croatian',
    locale: {
      __typename: 'Locale' as const,
      language: 'hr',
      country: 'HR'
    }
  }
] as const
